
import React from 'react'
import { FaTimes } from '@react-icons/all-files/fa/FaTimes';

const CircularCloseButton = (props) => {
  const { onClick, top = 0, right = 0 } = props
  return (
    <div onClick={() => onClick()} style={{ top: top, right: right }} className='circular-close-button-wrapper'>
      <FaTimes className='close-button-icon' />
    </div>
  )
}

export default CircularCloseButton